
// constants as defined in RevoXef’s App\Models\Menu\TablePrice
const PERCENTAGE = 0
const PRICE = 1

export default {
  PERCENTAGE,
  PRICE,
}
